import { UseYN } from 'src/api/infra';

export function toBoolean(useYN: UseYN): boolean {
  return useYN === 'Y';
}

export function toUseYN(b: boolean): UseYN {
  return b ? UseYN.Y : UseYN.N;
}
